import React from "react";
import { cn } from "../../lib/utils";

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-10 w-full rounded-md bg-input border border-input px-3 py-2 text-sm text-foreground",
        "placeholder:text-muted-foreground",
        "focus:ring-2 focus:ring-ring focus:ring-offset-0 focus:outline-none",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "transition-all duration-200",
        className
      )}
      ref={ref}
      {...props}
    />
  );
});

Input.displayName = "Input";

const Label = React.forwardRef(({ className, ...props }, ref) => (
  <label
    ref={ref}
    className={cn(
      "font-heading text-parchment text-xs tracking-wider uppercase",
      className
    )}
    {...props}
  />
));

Label.displayName = "Label";

export { Input, Label };
